export var AccessTokenQueryKey;
(function (AccessTokenQueryKey) {
    AccessTokenQueryKey["AccessTokens"] = "AccessTokens";
    AccessTokenQueryKey["GetClients"] = "AccessTokens/Clients";
    AccessTokenQueryKey["GetScopes"] = "AccessTokens/Scopes";
})(AccessTokenQueryKey || (AccessTokenQueryKey = {}));
